var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDealerLocatorLocationMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.0048828,12c-3.3085938,0-6,2.6914062-6,6s2.6914062,6,6,6s6-2.6914062,6-6S27.3134766,12,24.0048828,12z  M24.0048828,22c-2.2060547,0-4-1.7944336-4-4s1.7939453-4,4-4s4,1.7944336,4,4S26.2109375,22,24.0048828,22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0048828,2c-8.8222656,0-16,7.1777344-16,16c0,5.8666992,2.6474609,9.8129883,6.3105469,15.2744141 l7.8212891,11.7260742C22.5546875,45.6264648,23.2529297,46,24.0048828,46s1.4511719-0.3735352,1.8691406-1.0004883 l7.8203125-11.7250977C37.3574219,27.8129883,40.0048828,23.8666992,40.0048828,18C40.0048828,9.1777344,32.8271484,2,24.0048828,2 z M32.0332031,32.1601562l-7.8232422,11.7299805c-0.0917969,0.1367188-0.3173828,0.1381836-0.4091797,0.0004883 l-7.8242188-11.7304688C12.5097656,26.9921875,10.0048828,23.2578125,10.0048828,18c0-7.7197266,6.2802734-14,14-14 s14,6.2802734,14,14C38.0048828,23.2578125,35.5,26.9921875,32.0332031,32.1601562z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealerLocatorLocationMedium);
export default __webpack_public_path__ + "static/media/dealer-locator-location--medium.5d6203c03eaf2ce945a12f4ea00c18a4.svg";
export { ForwardRef as ReactComponent };